import { render } from "./AdminFinancialDashboardView.vue?vue&type=template&id=efdbe1ec&scoped=true"
import script from "./AdminFinancialDashboardView.vue?vue&type=script&lang=js"
export * from "./AdminFinancialDashboardView.vue?vue&type=script&lang=js"

import "./AdminFinancialDashboardView.vue?vue&type=style&index=0&id=efdbe1ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efdbe1ec"]])

export default __exports__